import { createRouter, createWebHistory } from 'vue-router';
// import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('../views/Hidraliso/HidralisoPage.vue'),
  },
  {
    path: '/folicap',
    name: '/folicap',
    component: () => import('../views/Folixil/FolixilPromoDoublePage.vue'),
  },
  {
    path: '/folicapprices',
    name: '/folicapprices',
    component: () => import('../views/Folixil/FolixilCheckout.vue'),
  },
  {
    path: '/folicappricesdouble',
    name: '/folicappricesdouble',
    component: () => import('../views/Folixil/FolixilPromoDoubleCheckout.vue'),
  },
  {
    path: '/sosla',
    name: '/sosla',
    component: () => import('../views/LizzAnte/LizzAntePage.vue'),
  },
  {
    path: '/soslaprices',
    name: '/soslaprices',
    component: () => import('../views/LizzAnte/LizzAnteCheckout.vue'),
  },
  // {
  //   path: '/soslapricesblack',
  //   name: '/soslapricesblack',
  //   component: () => import('../views/LizzAnte/LizzAnteCheckoutBlackFriday.vue'),
  // },
  {
    path: '/hidraliso',
    name: '/hidraliso',
    component: () => import('../views/Hidraliso/HidralisoPageReconstruhair.vue'),
  },
  {
    path: '/hidralisoprices',
    name: '/hidralisoprices',
    component: () => import('../views/Hidraliso/HidralisoCheckout.vue'),
  },
  // {
  //   path: '/rosamazonica',
  //   name: '/rosamazonica',
  //   component: () => import('../views/RAmazonica/RosaAmazonca.vue'),
  // },
  // {
  //   path: '/hidralisoarganprices',
  //   name: '/hidralisoarganprices',
  //   component: () => import('../views/HidralisoChechoutArganOil.vue'),
  // }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

export default router;
